module.exports = __webpack_public_path__ + "img/logo_barmanager_black.dbb7e08a.svg";